import React from 'react'

export default props => (
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><title>Artboard 2v2</title><rect x="0.24" y="0.21" width="214.18" height="214.18"/><rect x="285.82" y="0.21" width="214.18" height="214.18"/><rect x="0.24" y="285.79" width="214.18" height="214.18"/><rect x="285.82" y="285.79" width="214.18" height="214.18"/></svg>
)



// WEBPACK FOOTER //
// ./src/App/Menu/MenuHome/portfolio-icon-svg.js